import * as angular from "angular";

export class WorkflowService {
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.v2Root = "/v2/workflow";
    }
    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.id, data);
    }
    delete(data: any): Promise<object> {
        return this.$http.delete(this.v2Root + "/" + data.id, data);
    }
}
angular.module("vcServices").service("WorkflowService", WorkflowService);
